module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-content', {
    attrs: {
      "page-title": "Landing Page"
    }
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 17
    }
  }, _vm._l((_vm.markers), function(m) {
    return _c('gmap-marker', {
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21f564ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing.vue
// module id = 531
// module chunks = 83